import * as React from "react";
import { BetBtn } from "sb-resp-ui";
import { Market, Selection } from "../../data/models";
import { observer } from "mobx-react";

@observer
export class MarketButtons extends React.Component<{
    event: any
    market: Market
    isInSlip: Function
    handler: Function
}, {}> {
    selections: Selection[];

    constructor(props) {
        super(props)
        this.selections = [];
    }

    sortSelectionsByPosition(selections): Selection[] {
        return selections.sort((s1, s2) => (s1.position - s2.position));
    }

    getSelectionText(selection: Selection): string {
        return selection.id && selection.odds ? selection.odds.toString() : selection.title ? selection.title : " "
    }

    getQAvalue(isQA: boolean): number {
        return isQA ? 1 : 0;
    }

    getLineGroupID(market: Market): number {
        return market.lineGroupID ? parseInt(market.lineGroupID) : 0;
    }

    renderMarketButtons(event) {
        return (this.selections.map((selection, index) => {
            let isValidSelection = !isNaN(selection.lineType);
            let isQAValue: number = this.getQAvalue(this.props.market.isQA);
            let selectionHandler = this.props.handler.bind(this, this.props.market, selection);
            let isInSlip = this.props.isInSlip.call(this, parseInt(event.id), parseInt(this.props.market.id),
                parseInt(selection.id), this.getLineGroupID(this.props.market),
                selection.position, selection.lineType, event.isLive, this.props.market.isQA) ? "chosenBet" : "";
            return (isValidSelection ? <BetBtn key={`${index * (index - 1)}_${selection.id}`}
                modifier={`rj-sports-multiview__bet-btn UniqueOdd_${selection.id}_${isQAValue} ${isInSlip}`}
                odd={this.getSelectionText(selection)}
                isDisabled={!selection.id || selection.odds === undefined || isNaN(selection.odds)}
                handler={selectionHandler}
            /> : "")
        }
        ))
    }

    render() {

        this.selections = this.sortSelectionsByPosition(this.props.market.selections.slice());
        return (
            <div className="rj-sports-multiview__bet-btns-holder">
                {this.renderMarketButtons(this.props.event)}
            </div>
        )
    }
}